import React from 'react';

import ClientDataBanner from 'src/routes/Checkout/components/ClientDataBanner';
import type { PropsFromRedux } from '.';
import { Container } from '../../../../routes/styles';

export const ClientRoute = (props: PropsFromRedux) => {
  const { isMobile } = props;

  return (
    <Container $isMobile={isMobile}>
      <ClientDataBanner isHotelOnly={false} />
    </Container>
  );
};
